"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _KYCLevel = _interopRequireDefault(require("../KYC/KYCLevel"));
var _kycLevelsVerificationPropsHelper = require("../KYC/kycLevelsVerificationPropsHelper");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var KYCManualLevelsComponent = function KYCManualLevelsComponent(props) {
  var highlightStyle = props.highlightStyle,
    level1 = props.level1,
    level2 = props.level2,
    level3 = props.level3,
    level4 = props.level4,
    levelIncreaseStatus = props.levelIncreaseStatus,
    openKYCSidePane = props.openKYCSidePane,
    verificationLevel = props.verificationLevel;
  var level1Props = (0, _kycLevelsVerificationPropsHelper.getManualLevel1VerificationProps)(verificationLevel);
  var level2Props = (0, _kycLevelsVerificationPropsHelper.getManualLevel2VerificationProps)(verificationLevel, levelIncreaseStatus);
  var level3Props = (0, _kycLevelsVerificationPropsHelper.getManualLevel3VerificationProps)(verificationLevel, levelIncreaseStatus);
  var level4Props = (0, _kycLevelsVerificationPropsHelper.getManualLevel4VerificationProps)(verificationLevel, levelIncreaseStatus);
  return [level1 && /*#__PURE__*/_react["default"].createElement(_KYCLevel["default"], _extends({
    key: level1.level,
    verified: true,
    config: level1
  }, level1Props, {
    highlightStyle: highlightStyle
  })), level2 && /*#__PURE__*/_react["default"].createElement(_KYCLevel["default"], _extends({
    key: level2.level,
    config: level2
  }, level2Props, {
    openPane: openKYCSidePane,
    highlightStyle: highlightStyle
  })), level3 && /*#__PURE__*/_react["default"].createElement(_KYCLevel["default"], _extends({
    key: level3.level,
    config: level3
  }, level3Props, {
    openPane: openKYCSidePane,
    highlightStyle: highlightStyle
  })), level4 && /*#__PURE__*/_react["default"].createElement(_KYCLevel["default"], _extends({
    key: level4.level,
    config: level4
  }, level4Props, {
    openPane: openKYCSidePane,
    highlightStyle: highlightStyle
  }))];
};
var _default = exports["default"] = KYCManualLevelsComponent;